module.exports = __webpack_public_path__ + "static/media/9DESA6.b3e8922d.jpg";